export default __webpack_public_path__ + "static/media/parmegiana@3x.fd09363a.jpg";